import Lottie from "lottie-react";
import loadingAnimation from "../Animations/Loading.json";

function Loader() {
  return (
    <div style={{ width: "100vw", height: "100vh",backgroundColor:"black",display:"flex",justifyContent:"center",alignItems:"center" }}>
      <Lottie animationData={loadingAnimation} />
    </div>
  );
}

export default Loader;